import React, { useState, useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Accueil from "./containers/Accueil";
import Contact from "./components/Contact";
import Brands from "./components/Brands";
import Presentation from "./components/Presentation";
import Legal from "./components/Legal";
import { history } from "./helpers";
import { getWebsiteDBRef } from "./helpers";

const NoMatchRoute = () => <div>404 Page</div>;

const App = () => {
  const [website, setWebsite] = useState({});
  const siteId = window.Config.siteId;
  useEffect(() => {
    getWebsiteDBRef(siteId).on("value", (snapshot) => {
      setWebsite(snapshot.val());
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="App">
      <Router history={history}>
        <Header website={website} />
        <div className="container container-bg main-container">
          <Switch>
            <Route
              exact
              path="/contact"
              component={() => <Contact website={website} />}
            ></Route>
            <Route path="/marques">
              <Brands website={website} />
            </Route>
            <Route path="/Presentation">
              <Presentation website={website} />
            </Route>
            <Route path="/legal">
              <Legal />
            </Route>
            <Route path="/">
              <Accueil website={website} />
            </Route>
            <Route component={NoMatchRoute} />
          </Switch>
        </div>
        <Footer website={website} />
      </Router>
    </div>
  );
};

export default App;
